export class User {
    constructor(
        public Token?: string,
        public UserID?: string,
        public ClinicID?: string,
        public ClinicName?: string,
        public FirstName?: string,
        public MiddleName?: string,
        public LastName?: string,
        public DateOfBirth?: string,
        public Email?: string,
        public Phone?: string,
        public Password?: string,
        public UserRoleID?: Number,
        public CreatedBy?: string,
        public CreatedOn?: Date,
        public bDeleted?: boolean,
        public DeletedBy?: string,
        public DeletedOn?: Date,
        public bDeleteRequested?: boolean,
        public DeleteRequestOn?: Date
    ) {}
}
